import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { CustomerBrand } from '@shared/config'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useTasksKanbanStore } from './store'

interface TaskRelationCustomerReturn {
  refRespondUrl: ComputedRef<string | null>
  refHasCustomer: ComputedRef<boolean>
  refIsGo: ComputedRef<boolean>
  refBrand: ComputedRef<CustomerBrand | null>
  refHref: ComputedRef<string>
  refLabel: ComputedRef<string>
}

export const useTaskRelationCustomer = (): TaskRelationCustomerReturn => {
  const tasksKanbanStore = useTasksKanbanStore()

  const refHasCustomer = computed<boolean>(() => !!tasksKanbanStore.getCustomer)

  const refIsGo = computed<boolean>(() => tasksKanbanStore.getCustomer?.is_go ?? false)

  const refBrand = computed<CustomerBrand | null>(() => tasksKanbanStore.getCustomer?.brand ?? null)

  const refHref = computed<string>(() => {
    return resolveUrl(AppRoute.CustomersShow, { id: tasksKanbanStore.getCustomer?.id }) ?? ''
  })

  const refLabel = computed<string>(() => {
    const name = tasksKanbanStore.getCustomer?.full_name
    const id = tasksKanbanStore.getCustomer?.id
    return `${name} #${id}`
  })

  const refRespondUrl = computed(() => tasksKanbanStore.getCustomer?.respond_url || null)

  return {
    refHasCustomer,
    refIsGo,
    refBrand,
    refRespondUrl,
    refHref,
    refLabel,
  }
}
